import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { WebcamImage } from 'ngx-webcam';

export enum SELECTED_DOC_FORM_FIELDS {
  DOC_NAME = 'docName',
  DOCUMENT = 'document',
}

export const SELECTED_DOC_ID_PREFIX = 'ib-document-entity-';
export interface ISelectedDocument {
  name: string;
  id: string;
  webcamImage?: WebcamImage;
  file?: File;
  base64?: string;
  isFileImage?: boolean;
  isFilePdf?: boolean;
  createdAt: Date;
  sizeBytes: number;
}

@Component({
  selector: 'ib-selected-docs',
  templateUrl: './selected-docs.component.html',
})
export class SelectedDocsComponent {
  @Input() docsMainFormGroup!: FormGroup;
  @Input() docsFormGroupsMap!: Record<string, FormGroup>;
  @Input() setFocusToAdded?: boolean;
  @Input() docs: Array<ISelectedDocument>;

  public docsNamesFormGroup = new FormGroup({});
  public docsFormGroups: Record<string, FormGroup>;

  @Output() removeDoc = new EventEmitter<string>();
}
